<template>
  <el-button type="text" style="color: #F56C6C" @click="deleteList"
    >删除</el-button
  >
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    deleteList() {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('sureDel', true)
        })
        .catch(() => {
          this.$emit('sureDel', false)
        })
    },
  },
}
</script>
